export const CLASS_NAME = 'cst-chart-axis-bottom'
